export const colors = {
	blank: "#ffffff",
	body: "#000000",
	brandPrimary: "#C7B584",
	brandHighlight: "#977b59",
	offColor: "#cecece",
	inactiveColor: "#868686",
	enquireButton: "#E7D0A9"
}

export const fonts = {
	main: "'Gotham', Helvetica, Arial, sans-serif",
  header: "'Freight Big Pro', Times, serif"
}

export const padding = {
	inner: 3.5,
	outer: 21.5,
	tabInner: 2.5,
	tabOuter: 5,
	mobInner: 1,
	mobOuter: 4
}

export const time = 0.3;

export const easings = {
	easeOutQuint: 'cubic-bezier(0.23, 1, 0.32, 1)',
	easeInOut: 'ease-in-out'
}
